import Image from 'next/image';
import { css } from '@bts-web/utils-style-engine';
import { type TTransfersNextStepStateWithActions } from '../../../crypto-transfers/utils/useTransfersNextStepState.client';
import { RegularChevronDown } from '../../svgIcons';

const transactionItemsStyle = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 'small',
});

const arrowStyles = css({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
});

const arrowStart = css({
  width: 4,
  height: 4,
  borderRadius: 50,
  backgroundColor: 'neutrals.fill_tertiary',
});

const arrowLine = css({
  width: 56,
  height: 1,
  backgroundColor: 'neutrals.fill_tertiary',
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
});

const arrowHeadStyles = css({
  position: 'absolute',
  right: -4,
  color: 'neutrals.fill_tertiary',
});

const networkImageStyles = css({
  backgroundColor: 'screen_background.primary',
});

const receiverItemStyle = css({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  width: 48,
  height: 48,
  borderRadius: '32px',
  color: 'neutrals.text_secondary',
  backgroundColor: 'neutrals.fill_quaternary',
  fontSize: 'title.medium_medium',
  fontWeight: 'title.medium_medium',
  lineHeight: 'title.medium_medium',
  letterSpacing: 'title.medium_medium',
});

const NetworkTransfer = ({
  networkData,
  assetData,
  walletData,
}: {
  assetData: TTransfersNextStepStateWithActions['selectedAssetData'];
  networkData: TTransfersNextStepStateWithActions['selectedNetworkData'];
  walletData: NonNullable<
    TTransfersNextStepStateWithActions['createdWithdrawalOfferData']
  >['address'];
}): React.ReactElement => {
  let walletAbbreviation = 'EA';

  if (walletData?.userOwned) {
    walletAbbreviation = 'ME';
  }

  if (walletData?.ownerLegalName) {
    const [firstName, lastName] = walletData.ownerLegalName.split(' ');

    walletAbbreviation = `${firstName[0].toUpperCase()}${lastName[0].toUpperCase()}`;
  }

  return (
    <div data-testid="network-transfer" className={transactionItemsStyle}>
      <Image
        width={48}
        height={48}
        src={assetData?.logoUrl as string}
        alt={assetData?.name as string}
      />

      <div className={arrowStyles}>
        <div className={arrowStart} />

        <div className={arrowLine}>
          <Image
            className={networkImageStyles}
            width={32}
            height={32}
            src={networkData?.logoUrl as string}
            alt={networkData?.name as string}
          />

          <RegularChevronDown className={arrowHeadStyles} size={12} />
        </div>
      </div>

      <div className={receiverItemStyle}>{walletAbbreviation}</div>
    </div>
  );
};

export { NetworkTransfer };
